// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"f3f6b1c8","527":"2489e329","832":"8a9f02cd"}[chunkId] + ".chunk.css";
};